import { createFileRoute } from "@tanstack/react-router"

import { AffiliationsStep } from "@/features/membership/application/components/affiliations-step"

export const Route = createFileRoute("/membership/apply/affiliations")({
  component: AffiliationsStep,
})
